import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  ShoppingBag,
  Users,
  Bell,
  DollarSign,
  Plus,
  Tag,
  Layers,
  List,
} from "lucide-react";
import { SERVER_URL } from "../../constants";
import Usero from './Users'
import RecentOrders from "./RecentOrder"; // Assuming RecentOrders is a separate component

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalOrders: 0,
    totalProducts: 0,
    totalCategories: 0,
    totalFavs: 0,
  });const [totalSales, setTotalSales] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [userRes, orderRes, productRes, categoryRes, favRes] = await Promise.all([
          fetch(`${SERVER_URL}/api/v1/totaluser`),
          fetch(`${SERVER_URL}/api/v1/totalorder`),
          fetch(`${SERVER_URL}/api/v1/totalproduct`),
          fetch(`${SERVER_URL}/api/v1/totalcategory`),
          fetch(`${SERVER_URL}/api/v1/totalfav`),
        ]);

        const userData = await userRes.json();
        const orderData = await orderRes.json();
        const productData = await productRes.json();
        const categoryData = await categoryRes.json();
        const favData = await favRes.json();

        setStats({
          totalUsers: userData.userlength,
          totalOrders: orderData.orderlength,
          totalProducts: productData.productlength,
          totalCategories: categoryData.categorylength,
          totalFavs: favData.favlength,
        });
      } catch (error) {
        console.error("Failed to fetch stats:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="p-2 sm:p-4 md:p-6 lg:p-8 space-y-4 sm:space-y-6 md:space-y-8 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 min-h-screen">
      <motion.h1
        className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600 text-center mb-4 sm:mb-6 md:mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Dashboard
      </motion.h1>

      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-4 md:gap-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {[{
          title: "Total Sales",
          value: '₹'+totalSales,
          icon: ShoppingBag,
        },
        {
          title: "Total Users",
          value: stats.totalUsers,
          icon: Users,
        },
        {
          title: "Total Products",
          value: stats.totalProducts,
          icon: Tag,
        },
        {
          title: "Total Categories",
          value: stats.totalCategories,
          icon: Layers,
        },
        
        {
          title: "Total Orders",
          value: stats.totalOrders,
          icon: List,
        },
        {
          title: "Revenue",
          value: '₹'+totalSales,
          icon: DollarSign,
        },
        {
          title: "Favorite Products",
          value: stats.totalFavs,
          icon: Plus,
        }].map((item, index) => (
          <motion.div
            key={index}
            className="bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-600 p-3 sm:p-4 md:p-6 rounded-xl shadow-lg relative overflow-hidden"
            whileHover={{ scale: 1.03, rotate: 0.5 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="absolute inset-0 bg-white opacity-10 transform rotate-12 scale-150"></div>
            <div className="relative flex flex-col justify-between h-full">
              <h3 className="text-sm sm:text-base md:text-lg font-semibold text-white mb-1 sm:mb-2">
                {item.title}
              </h3>
              <div className="flex items-end justify-between">
                <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-yellow-300">
                  {item.value}
                </p>
                <item.icon className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white opacity-80" />
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {/* Recent Orders Component */}
      <Usero/>
      
      <RecentOrders setTotalSales={setTotalSales} />
    </div>
  );
};

export default Dashboard;
